import { getOidc, useOidc } from '../contexts/OidcContext/OidcContext';
import { ResourceManagerRule } from './gen';
import { IRuleGeneric } from './types';

export { default as globalAxios } from 'axios';

export function useAppAuthValue(key: string): string | null {
    const oidcState = useOidc();

    if (key === 'authToken') {
        return oidcState.tokens?.accessToken || null;
    }

    return null;
}

export function useApiBasePath() {
    return getDevRootUrl();
}

export function useAuthQueryKey() {
    return useAuthorizationToken();
}

export const useAuthorizationToken = async () => {
    const oidc = getOidc();
    return (await oidc).getTokens().accessToken;
};

export function getDevRootUrl() {
    return (
        // local storage overridable path
        (localStorage && localStorage.getItem && localStorage.getItem('DEV_ROOT_API_URL')) ||
        // or default path from config (local)
        import.meta.env.VITE_DEFAULT_ROOT_API_URL ||
        // or same base path as the one where is running the backend (all instances except local)
        window.location.origin + import.meta.env.VITE_DEFAULT_RELATIVE_API_URL
    );
}

export const isResourceManagerRule = (rule?: IRuleGeneric | null): rule is ResourceManagerRule =>
    rule?.type === 'ResourceManagerRule';
